import { render, staticRenderFns } from "./payment-by-service.vue?vue&type=template&id=13fbf477"
import script from "./payment-by-service.vue?vue&type=script&lang=js"
export * from "./payment-by-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports